import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CommunityPage from './pages/CommunityPage';
import StoryPage from './pages/StoryPage';
import TeamPage from './pages/TeamPage';
import GuidelinesPage from './pages/GuidelinesPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CommunityPage />} />
        <Route path="/story" element={<StoryPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/guidelines" element={<GuidelinesPage />} />
      </Routes>
    </Router>
  );
}

export default App;